<template>
	<div>
		<div v-show="type === 'klarna'">
			<p v-text="$__('checkout.stripe.klarna.description')" />
			<div v-if="stripeData.cardErrors" id="card-errors" role="alert" class="d-block invalid-feedback small">
				{{ stripeData.cardErrors }}
			</div>
		</div>
		<div v-show="type === 'stripe'" ref="paymentArea" class="payment-area">
			<div class="form-group">
				<label for="stripe-card-number" v-text="$__('checkout.stripe.field.card')" />
				<div id="stripe-card-number" class="form-control" />
			</div>
			<div class="row">
				<div class="col-md-6">
					<div class="form-group">
						<label for="stripe-card-expiry" v-text="$__('checkout.stripe.field.expiration')" />
						<div id="stripe-card-expiry" class="form-control" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label for="stripe-card-cvc" v-text="$__('checkout.stripe.field.cvc')" />
						<div id="stripe-card-cvc" class="form-control" />
					</div>
				</div>
			</div>
			<div v-if="stripeData.cardErrors" id="card-errors" role="alert" class="d-block invalid-feedback small">
				{{ stripeData.cardErrors }}
			</div>
		</div>
	</div>
</template>
<script>
import { loadStripe } from '@stripe/stripe-js'

export default {
	name: 'Stripe',
	props: {
		stripePk: {
			type: String,
			required: true
		},
		type: {
			type: String
		},
		klarnaValidCountries: {
			type: Array
		}
	},
	data () {
		return {
			stripe: null,
			stripeData: {
				cardNumber: '',
				cardExpiry: '',
				cardCvc: '',
				cardErrors: ''
			},
			cardNetworks: [],
			stripeStyle: {
				base: {
					//color: 'white',
					fontFamily: 'Rubik, sans-serif',
					fontSmoothing: 'antialiased',
					fontSize: '1rem',
					fontWeight: 400,
					lineHeight: '1.666',
					'::placeholder': {
						color: '#666'
					}
				},
				invalid: {
					color: '#dc3545',
					iconColor: '#dc3545',
					borderColor: '#dc3545'
				}
			},
		}
	},
	methods: {
		onCardChange (event) {
			if (event.complete) {
				this.stripeData.cardErrors = ''
			}
			if (event.error) {
				this.stripeData.cardErrors = event.error.message
			}
		},
		stripeValidate (countryCode) {
			if (this.type === 'stripe') {
				if (!this.stripeData.cardNumber._complete) {
					document.querySelector('#stripe-card-number')?.classList.add('StripeElement--invalid')
				}
				if (!this.stripeData.cardExpiry._complete) {
					document.querySelector('#stripe-card-expiry')?.classList.add('StripeElement--invalid')
				}
				if (!this.stripeData.cardCvc._complete) {
					document.querySelector('#stripe-card-cvc')?.classList.add('StripeElement--invalid')
				}

				if (!this.stripeData.cardNumber._complete || !this.stripeData.cardExpiry._complete || !this.stripeData.cardCvc._complete) {
					this.stripeData.cardErrors = this.$__('checkout.stripe.error.empty')
					return false
				}
				this.stripeData.cardErrors = ''

			} else if (this.type === 'klarna') {
				if (!this.klarnaValidCountries.includes(countryCode)) {
					this.stripeData.cardErrors = this.$__('checkout.stripe.klarna.not.available')
					return false
				}
				this.stripeData.cardErrors = ''
			}
			return true
		},
		initStripe () {
			const elements = this.stripe.elements()

			this.stripeData.cardNumber = elements.create('cardNumber', { style: this.stripeStyle, showIcon: true, preferredNetwork: ['mastercard', 'cartes_bancaires', 'visa'] })
			this.stripeData.cardNumber.mount('#stripe-card-number')
			this.stripeData.cardNumber.on('change', (event) => {
				this.onCardChange(event)
			})

			this.stripeData.cardExpiry = elements.create('cardExpiry', { style: this.stripeStyle })
			this.stripeData.cardExpiry.mount('#stripe-card-expiry')
			this.stripeData.cardExpiry.on('change', (event) => {
				this.onCardChange(event)
			})

			this.stripeData.cardCvc = elements.create('cardCvc', { style: this.stripeStyle })
			this.stripeData.cardCvc.mount('#stripe-card-cvc')
			this.stripeData.cardCvc.on('change', (event) => {
				this.onCardChange(event)
			})
		},

		async processPayment (type, clientSecret, data) {
			if (type === 'klarna') {
				await this.stripe.confirmKlarnaPayment(
					clientSecret,
					{
						payment_method: {
							billing_details: {
								email: data.email,
								address: {
									country: data.country
								},
							},
						},
						return_url: window.location.href + '?order_id=' + data.orderId
					})
			} else {
				return this.stripe.confirmCardPayment(
					clientSecret,
					{
						payment_method: {
							card: this.stripeData.cardNumber,
							billing_details: {
								name: data.name,
								email: data.email,
								phone: data.phone,
								address: {
									line1: data.address,
									city: data.town,
									postal_code: data.post,
									country: data.country
								}
							}
						}
					})
			}
		},

		setError (error) {
			this.stripeData.cardErrors = error
		}
	},
	watch: {
		'stripeData.cardNetworks': (newNetworks) => {
			if (newNetworks.length > 0) {
				this.stripeData.selectedNetwork = newNetworks[0];
			}
		}
	},
	async mounted() {
		this.stripe = await loadStripe(this.stripePk)
		setTimeout(() => {
			this.initStripe()
		}, 100)
	}
}
</script>
